
import HierarchySquare2 from "../../../assets/filled/HierarchySquare2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HierarchySquare2Icon({ className, dataTestid = "HierarchySquare2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HierarchySquare2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
